<template><section><!-- ---x
title: ES6系列之Proxy
date: 2022-10-20
tags: ES6系列
set: ES6
--- -->
<p>Proxy可以理解为，在目标对象之前架设一层<code v-pre>拦截</code>，外界对该对象的访问，都必须先通过这层拦截，因此提供了一种机制，可以对外界的访问进行过滤和改写。下面的例子中，<code v-pre>Proxy</code>实际上重载了点运算符，即用自己的定义覆盖了原始定义。</p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">var</span> obj = <span class="hljs-keyword">new</span> <span class="hljs-built_in">Proxy</span>({}, {
    <span class="hljs-attr">get</span>: <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">target, propKey, receiver</span>) </span>{
        <span class="hljs-built_in">console</span>.log(<span class="hljs-string">`getting <span class="hljs-subst">${propKey}</span>!`</span>)
        <span class="hljs-keyword">return</span> <span class="hljs-built_in">Reflect</span>.get(target, propKey, receiver)
    },
    <span class="hljs-attr">set</span>: <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">target, propKey, value, receiver</span>) </span>{
        <span class="hljs-built_in">console</span>.log(<span class="hljs-string">`setting <span class="hljs-subst">${propKey}</span>!`</span>)
        <span class="hljs-keyword">return</span> <span class="hljs-built_in">Reflect</span>.set(target, propKey, value, receiver)
    }
})
</code></pre>
<p>输出结果是：</p>
<pre v-pre><code v-pre class="language-javascript">obj.count = <span class="hljs-number">1</span>
<span class="hljs-comment">// setting count!</span>
++obj.count
<span class="hljs-comment">// getting count!</span>
<span class="hljs-comment">// setting count!</span>
<span class="hljs-comment">// 2</span>
</code></pre>
</section></template>

